"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValidatorFactory = void 0;
const FieldValidator_1 = require("../validator/FieldValidator");
class FieldValidatorFactory {
    static create(validators) {
        return new (class a extends FieldValidator_1.FieldValidator {
            constructor() {
                super();
                this.rules = validators.map(({ code, validator }) => {
                    return {
                        code,
                        validator,
                    };
                });
            }
        })();
    }
    static createOptional(validators) {
        return new (class a extends FieldValidator_1.FieldValidator {
            constructor() {
                super();
                this.rules = validators.map(({ code, validator }) => {
                    return {
                        code,
                        validator: (value, data) => {
                            if (!value) {
                                return true;
                            }
                            return validator(value, data);
                        },
                    };
                });
            }
        })();
    }
}
exports.FieldValidatorFactory = FieldValidatorFactory;
//# sourceMappingURL=FieldValidatorFactory.js.map